"use client";

import { c as _c } from "react/compiler-runtime";
import { useSeizeSettings } from "@/contexts/SeizeSettingsContext";
import { getCopiedDropLink } from "@/helpers/waves/drop-copy-link.helpers";
import { isWaveDirectMessage } from "@/helpers/waves/wave.helpers";
import React, { useState } from "react";
import { Tooltip } from "react-tooltip";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { useMyStreamOptional } from "@/contexts/wave/MyStreamContext";
interface WaveDropActionsCopyLinkProps {
  readonly drop: ApiDrop;
  readonly isDropdownItem?: boolean | undefined;
  readonly onCopy?: (() => void) | undefined;
}
const WaveDropActionsCopyLink: React.FC<WaveDropActionsCopyLinkProps> = t0 => {
  const $ = _c(36);
  const {
    drop,
    isDropdownItem: t1,
    onCopy
  } = t0;
  const isDropdownItem = t1 === undefined ? false : t1;
  const [copied, setCopied] = useState(false);
  const {
    isMemesWave
  } = useSeizeSettings();
  const myStream = useMyStreamOptional();
  let t2;
  if ($[0] !== myStream?.directMessages.list) {
    t2 = myStream?.directMessages.list ?? [];
    $[0] = myStream?.directMessages.list;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const directMessageWaves = t2;
  const isTemporaryDrop = _temp;
  let t3;
  if ($[2] !== directMessageWaves || $[3] !== drop || $[4] !== isMemesWave || $[5] !== onCopy) {
    t3 = () => {
      if (isTemporaryDrop(drop)) {
        return;
      }
      const waveDetails = drop.wave as unknown as {
        chat?: {
          scope?: {
            group?: {
              is_direct_message?: boolean | undefined;
            } | undefined;
          } | undefined;
        } | undefined;
      } ?? undefined;
      const isDirectMessage = isWaveDirectMessage(drop.wave.id, waveDetails, directMessageWaves);
      const dropLink = getCopiedDropLink({
        drop,
        isDirectMessage,
        isMemesWave
      });
      navigator.clipboard.writeText(dropLink).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
        onCopy?.();
      });
    };
    $[2] = directMessageWaves;
    $[3] = drop;
    $[4] = isMemesWave;
    $[5] = onCopy;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const copyToClipboard = t3;
  let t4;
  if ($[7] !== drop) {
    t4 = isTemporaryDrop(drop);
    $[7] = drop;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const isDisabled = t4;
  let t5;
  if ($[9] !== copied || $[10] !== isDisabled) {
    t5 = () => {
      if (isDisabled) {
        return "Unavailable";
      }
      if (copied) {
        return "Copied!";
      }
      return "Copy link";
    };
    $[9] = copied;
    $[10] = isDisabled;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const getLinkText = t5;
  if (isDropdownItem) {
    const t6 = `tw-flex tw-w-full tw-items-center tw-gap-x-3 tw-rounded-lg tw-border-0 tw-bg-transparent tw-px-3 tw-py-2 tw-transition-colors tw-duration-200 ${isDisabled ? "tw-cursor-default tw-text-iron-500 tw-opacity-50" : "tw-cursor-pointer tw-text-iron-300 desktop-hover:hover:tw-bg-iron-800"}`;
    let t7;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <svg className="tw-h-4 tw-w-4 tw-flex-shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" /></svg>;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    const t8 = getLinkText();
    let t9;
    if ($[13] !== t8) {
      t9 = <span className="tw-text-sm tw-font-medium">{t8}</span>;
      $[13] = t8;
      $[14] = t9;
    } else {
      t9 = $[14];
    }
    let t10;
    if ($[15] !== copyToClipboard || $[16] !== isDisabled || $[17] !== t6 || $[18] !== t9) {
      t10 = <button onClick={copyToClipboard} disabled={isDisabled} className={t6}>{t7}{t9}</button>;
      $[15] = copyToClipboard;
      $[16] = isDisabled;
      $[17] = t6;
      $[18] = t9;
      $[19] = t10;
    } else {
      t10 = $[19];
    }
    return t10;
  }
  const t6 = `icon tw-group tw-flex tw-h-full tw-items-center tw-gap-x-2 tw-rounded-full tw-border-0 tw-bg-transparent tw-px-2 tw-text-[0.8125rem] tw-font-medium tw-leading-5 tw-text-iron-500 tw-transition tw-duration-300 tw-ease-out ${isDisabled ? "tw-cursor-default tw-opacity-50" : "tw-cursor-pointer"}`;
  let t7;
  if ($[20] !== drop || $[21] !== isDisabled) {
    t7 = !isDisabled ? {
      "data-tooltip-id": `copy-link-${drop.id}`
    } : {};
    $[20] = drop;
    $[21] = isDisabled;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <svg className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-transition tw-duration-300 tw-ease-out" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" /></svg>;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== copyToClipboard || $[25] !== isDisabled || $[26] !== t6 || $[27] !== t7) {
    t9 = <button className={t6} onClick={copyToClipboard} disabled={isDisabled} aria-label="Copy link" {...t7}>{t8}</button>;
    $[24] = copyToClipboard;
    $[25] = isDisabled;
    $[26] = t6;
    $[27] = t7;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== drop || $[30] !== getLinkText || $[31] !== isDisabled) {
    t10 = !isDisabled && <Tooltip id={`copy-link-${drop.id}`} place="top" offset={8} opacity={1} style={{
      padding: "4px 8px",
      background: "#37373E",
      color: "white",
      fontSize: "13px",
      fontWeight: 500,
      borderRadius: "6px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      zIndex: 99999,
      pointerEvents: "none"
    }}><span className="tw-text-xs">{getLinkText()}</span></Tooltip>;
    $[29] = drop;
    $[30] = getLinkText;
    $[31] = isDisabled;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== t10 || $[34] !== t9) {
    t11 = <>{t9}{t10}</>;
    $[33] = t10;
    $[34] = t9;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  return t11;
};
export default WaveDropActionsCopyLink;
function _temp(drop_0) {
  return drop_0.id.startsWith("temp-");
}